module.exports = __webpack_public_path__ + "img/btn_home.e7c92ee1.svg";